module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"This page is under construction. Thank you for your interest!","buttonText":"Back to Home Page"},"ro":{"message":"Această pagină este în construcție. Mulțumim pentru interes!","buttonText":"Înapoi la pagina de pornire"}}')
  delete Component.options._Ctor
}
